module.exports = __webpack_public_path__ + "media/promotional/survival-c87cc04d.jpeg";